<template>
  <v-container fluid>
    <v-data-table
      dense
      v-model="districtAdminsSelected"
      :headers="headers"
      :items="items"
      :single-select="singleSelect"
      item-key="id"
      :loading="tableLoading"
      show-select
      class="elevation-0"
      checkbox-color="deep-purple"
      hide-default-footer
    >
      <template v-slot:item.schoolGroup="{ item }">
        <div v-if="item.schoolGroup" class="d-flex justify-start align-center">
          <span>{{item.schoolGroup.name}}</span>
        </div>
      </template>
      <template v-slot:item.fullName="{ item }">
        <span class="font-weight-bold">{{ item.firstname }} {{ item.lastname }} {{ item.lastname2nd }}</span>
      </template>
      <template v-slot:item.register_date="{ item }">
        <span v-if="item.creationDate" class="font-weight-bold">{{ item.creationDate | moment('MM/D/YYYY') }}</span>
        <span v-else class="orange--text darken-2 font-weight-bold">Vacio</span>
      </template>
      <template v-slot:item.state="{ item }">
        <span v-if="item.active"
              class="green--text font-weight-bold">{{ $t('students.active')}}</span>
        <span v-else
              class="orange--text darken-2 font-weight-bold">{{ $t('students.inactive')}}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row justify="center" align="center" no-gutters>
          <v-col cols="auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="info"
                  @click="editDistrictAdmin(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <!-- Toolbar para acciones múltiples -->
    <v-toolbar
      v-if="districtAdminsSelected.length > 0"
      dense
      flat
      color="grey lighten-3"
      class="mt-2"
    >
      <v-toolbar-title class="subtitle-2">
        {{ districtAdminsSelected.length }}
        {{
          districtAdminsSelected.length === 1
            ? 'administrador seleccionado'
            : 'administradores seleccionados'
        }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="red"
        outlined
        small
        @click="deleteSelected"
        :loading="deleteLoading"
        :disabled="deleteLoading"
      >
        <v-icon left small>mdi-delete</v-icon>
        Eliminar seleccionados
      </v-btn>
    </v-toolbar>

    <div class="text-center pt-2">
      <v-pagination
        @input="setValue($event)"
        v-model="page"
        :length="length"
        :total-visible="6"
        color="deep-purple lighten-3"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import LoadingMixin from '../../mixins/loading';
import snackbarMixin from '../../mixins/snackbar';
import districtAdminService from '../../services/districtAdmin.service';

export default {
  props: {
    items: { type: Array, default: () => ([]) },
    page: { type: Number, default: 1 },
    length: { type: Number, default: 1 },
    tableLoading: { type: Boolean, default: false },
  },
  data: () => ({
    singleSelect: false,
    districtAdminsSelected: [],
    deleteLoading: false,
    headers: [
      {
        text: 'Nombre Completo',
        align: 'start',
        sortable: false,
        value: 'fullName',
      },
      { text: 'Email', value: 'email' },
      { text: 'DNI', value: 'dni' },
      { text: 'Distrito', value: 'schoolGroup' },
      { text: 'Fecha de registro', value: 'register_date' },
      { text: 'Estado', value: 'state' },
      {
        text: 'Acciones', value: 'actions', sortable: false, align: 'center',
      },
    ],
  }),
  mixins: [LoadingMixin, snackbarMixin],
  methods: {
    setValue(page) {
      this.$emit('input', page);
    },
    editDistrictAdmin(districtAdmin) {
      this.$emit('edit', districtAdmin);
    },
    async deleteSelected() {
      this.deleteLoading = true;
      try {
        const ids = this.districtAdminsSelected.map((admin) => admin.id);

        await districtAdminService.deleteMultipleDistrictAdmins(ids);

        this.snackbarSuccess(
          `Se eliminaron ${ids.length} administradores correctamente`,
        );
        this.districtAdminsSelected = [];
        this.$emit('refresh');
      } catch (error) {
        const errorMessage = this.getErrorMessage(error);

        this.snackbarError(errorMessage);
      } finally {
        this.deleteLoading = false;
      }
    },
    getErrorMessage(error) {
      const data = error.response?.data;
      return data?.message || data?.title || error.message || 'Error al eliminar administradores';
    },
  },
  watch: {
    districtAdminsSelected(newVal) {
      this.$emit('selected', newVal);
    },
  },
};
</script>
